module.exports = __webpack_public_path__ + "img/4.ce498e5b.png";